export default __webpack_public_path__ + "static/media/Easier-_-Affordable.82f1a257.jpg";